import { createSelector } from 'reselect';
import { RootState } from 'reducers/rootReducer';

const getInstalmentReducer = (state: RootState) => state.instalmentReducer;

export const instalmentReducerSelector = createSelector(getInstalmentReducer, (res) => res);
export const instalmentFilters = createSelector(getInstalmentReducer, (res) => res.filters);
export const currentInstalmentsIDS = createSelector(getInstalmentReducer, (res) => res.currentInstalmentsIDS);
export const currentInstalments = createSelector(getInstalmentReducer, (res) => res.currentInstalment);
